import { AppBar, Box, Dialog, Grid, IconButton, Toolbar, Typography, Slide, Button, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@mui/material";
import { ReactComponent as ThreeDotsIcon } from "../Assets/svg/ThreeDotsIcon.svg";
import { ReactComponent as PhoneIcon } from "../Assets/svg/PhoneIcon.svg";
import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { ReactComponent as ArrowRightIcon } from "../Assets/svg/ArrowRightIcon.svg";
import { ReactComponent as CloseIcon } from "../Assets/svg/CloseIcon.svg";
import { ReactComponent as LabelsIcon } from "../Assets/svg/LabelsIcon.svg";
import { ReactComponent as HouseIcon } from "../Assets/svg/HouseIcon.svg";
import { ReactComponent as ShareIcon } from "../Assets/svg/ShareIcon.svg";
import { ReactComponent as SendIcon } from "../Assets/svg/SendIcon.svg";
import { ReactComponent as CalendarIcon } from "../Assets/svg/CalendarIcon.svg";
import { ReactComponent as PenIcon } from "../Assets/svg/PenIcon.svg";
import { ReactComponent as BackUpIcon } from "../Assets/svg/BackUpIcon.svg";
import { ReactComponent as DelIcon } from "../Assets/svg/DelIcon.svg";
import { ReactComponent as MailIcon } from "../Assets/svg/MailIcon.svg";
import { ReactComponent as RoundArrowsIcon } from "../Assets/svg/RoundArrowsIcon.svg";
import { ReactComponent as SettingIcon } from "../Assets/svg/SettingIcon.svg";
import { ReactComponent as GrayLocation } from "../Assets/svg/GrayLocation.svg";
import { ReactComponent as CheckIcon } from "../Assets/svg/CheckIcon.svg";
import { ReactComponent as GreenArrow } from "../Assets/svg/greenArrow.svg";
import { ReactComponent as MobileIcon } from "../Assets/svg/MobileIcon.svg";
// import { ReactComponent as GreenPlus } from "../Assets/svg/GreenPlus.svg";
import Cookies from 'js-cookie'

import moment from "moment-jalaali"
import { useUserStore } from '../store/user';
import http from '../api/axiosInstance';
import { useSnackbar } from 'notistack';
import DemandContactModal from "./DemandContactModal";
import { CheckPermissions } from "./CheckPermissions";
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
function PropItem(props) {
    const [openMoreOptionsModal, setOpenMoreOptionsModal] = useState(false)
    const [openLabelsModal, setOpenLabelsModal] = useState(false)
    const [buyLoading, setBuyLoading] = useState(false)
    const [ContactModal, setContactModal] = useState(false);
    const [openBackdrop, setOpenBackdrop] = React.useState(false);

    const userInfo = useUserStore((state) => state.userInfo)
    const accessToken = useUserStore((state) => state.accessToken)
    const locationId = useUserStore((state) => state.locationId)

    const navigate = useNavigate();

    const [deletePropModal, setDeletePropModal] = useState(false);
    const [deleteLading, setDeleteLading] = useState(false);


    const { propInfo } = props

  

    const handleClickOpenDeletePropModal = (id) => {
        setDeletePropModal(true);
    };
    const handleDeletePropModalClose = () => {
        setDeletePropModal(false);
    };

    const { enqueueSnackbar } = useSnackbar();

    const handleMoreOptionsModalClick = () => {
        setOpenMoreOptionsModal(true);
    };
    const handleMoreOptionsModalClose = () => {
        setOpenMoreOptionsModal(false);
    };

    const handleLabelsModalClick = () => {
        setOpenLabelsModal(true);
    };
    const handleLabelsModalClose = () => {
        setOpenLabelsModal(false);
    };

    const handleOpenContactModal = () => {
        setContactModal(true);
    };
    const handleContactModalClose = () => {
        setContactModal(false);
    };

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    };
    const handleToggleBackdrop = () => {
        setOpenBackdrop(!openBackdrop);
    };

    const handleBuyFile = () => {
        console.log("credit", userInfo.Credit)
        console.log("FilePrice", propInfo.FilePrice)
        setBuyLoading(true)
        if (userInfo.Credit >= propInfo.FilePrice) {
            try {
                http({
                    url: "/wallet/file/buy",
                    method: "POST",
                    data: {
                        "Properties": [propInfo.Id],
                        "LocationId": locationId
                    },
                    headers: {
                        "Authorization": `Bearer ${accessToken}`
                    }
                }).then((res) => {
                    // console.log("checkout_url", res.result.checkout_url)

                    if (res.data.result == false) {
                        const variant = 'error'
                        enqueueSnackbar(res.data.message, { variant });
                    } else {
                        window.open(res.data.result.checkout_url, '_blank', 'noreferrer');
                    }

                    setBuyLoading(false)
                });

            } catch (e) {
                console.error(e);
                if (e.result.data.result == false) {
                    const variant = 'error'
                    enqueueSnackbar(e.response.data.message, { variant });
                }


                setBuyLoading(false)
            }
        } else {
            const variant = 'error'
            enqueueSnackbar("کیف پول خود را شارژ کنید.", { variant });

            setBuyLoading(false)
        }

    }


    const handleDelete = async () => {
        setDeleteLading(true)
        try {
            await http({
                // url of the api endpoint (can be changed)
                url: `/applicants/${propInfo.Id}/delete`,
                method: "POST",
                // data: {
                //     "LocationId": locationId
                // },
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {

                if (res.data.result) {
                    const variant = 'success'
                    enqueueSnackbar("تقاضا شما با موفقیت حذف شد.", { variant });
                    props.handleDeletedProps(propInfo.Id)
                    handleMoreOptionsModalClose()

                }

                handleDeletePropModalClose()
                setDeleteLading(false)


            });
        } catch (e) {
            console.error(e);

            handleCloseBackdrop()
        }
    }

    return (<>
        <Box className={`dash-property-item ${propInfo.IsBought ? "IsBought" : ""}`} onClick={() => navigate(`/applicant/${propInfo.Id}`)}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '13px', mb: 1 }}>
                <Box>

                    <Box sx={{ color: '#000000' }}>
                        {propInfo.RequestSale == 1 && "خرید "}
                        {propInfo.RequestRent == 1 && "اجاره "}
                        {propInfo.PropertyTypes && propInfo.PropertyTypes[0] && ` | ${propInfo.PropertyTypes[0]}`}
                        {propInfo.PropertyTypes && propInfo.PropertyTypes[1] && ` | ${propInfo.PropertyTypes[1]}`}
                        {propInfo.PropertyTypes && propInfo.PropertyTypes[2] && ` | ${propInfo.PropertyTypes[2]}`}
                    </Box>

                </Box>
                <Box>
                    <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'center', gap: '10px' }}>
                        <Box>
                            <IconButton sx={{ bgcolor: '#D6ECD2!important' }} onClick={e => {
                                e.stopPropagation()
                                handleOpenContactModal()
                            }}>
                                <PhoneIcon />
                            </IconButton>
                        </Box>
                        <IconButton onClick={e => {
                            e.stopPropagation()
                            handleMoreOptionsModalClick()
                        }}>
                            <ThreeDotsIcon />
                        </IconButton>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'center', gap: '10px' }}>
                        <Box>{propInfo.ExpireDate && propInfo.ExpireDate < parseInt(+(new Date()) / 1000) ? "منقضی شده" : ""}</Box>
                        <Box>{propInfo.Row}</Box>
                    </Box>
                </Box>
            </Box>
            <Box sx={{ display: 'flex' }}>
                <Box sx={{ flex: '1' }}>
                    {propInfo.RequestSale == 1 ? <Box sx={{ fontSize: '13px', mt: 3 }}>قیمت از {propInfo.MinSalePrice.toLocaleString()} تا {propInfo.MaxSalePrice.toLocaleString()}</Box> : null}
                    {propInfo.RequestRent == 1 ? <Box sx={{ fontSize: '13px', mt: 3 }}>قیمت اجاره از {propInfo.MinRentPrice.toLocaleString()} تا {propInfo.MaxRentPrice.toLocaleString()}</Box> : null}
                    {propInfo.RequestRent == 1 ? <Box sx={{ fontSize: '13px', mt: 1 }}>قیمت رهن از {propInfo.MinMortgagePrice.toLocaleString()} تا {propInfo.MaxMortgagePrice.toLocaleString()}</Box> : null}
                </Box>
            </Box>
            <Box sx={{ display: 'flex', gap: '5px', fontSize: '13px', mt: 1 }}>
                <GrayLocation />
                <Box>
                    {propInfo.Areas && propInfo.Areas.length ? propInfo.Areas.toString() : "-"}
                    {/* {propInfo.Areas && propInfo.Areas.length ? propInfo.Areas.map((item,index) => {
                        return <Typography component="span" key={index}>{item}</Typography>
                    }) : "-"} */}
                </Box>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px', fontSize: '13px', mt: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', mt: 1 }}>
                    <Box>زیربنا از {propInfo.MinInfrastructure && propInfo.MinInfrastructure} تا {propInfo.MaxInfrastructure && propInfo.MaxInfrastructure} متر</Box>
                    <Box>مساحت از {propInfo.MinSpace && propInfo.MinSpace} تا {propInfo.MaxSpace && propInfo.MaxSpace} متر</Box>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '13px' }}>
                    <Box>
                        {moment.unix(propInfo.RegisterDate).format("jYYYY/jMM/jDD")}
                    </Box>
                </Box>
            </Box>

        </Box>

        {openMoreOptionsModal && <Dialog className="dialog-box"
            fullScreen
            open={openMoreOptionsModal}
            onClose={handleMoreOptionsModalClose}
            TransitionComponent={Transition}
        >
            <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                <Toolbar>

                    <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                        {/* انتخاب کنید */}
                    </Typography>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleMoreOptionsModalClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                    {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                </Toolbar>
            </AppBar>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', pt: 3, gap: '20px', px: 4 }}>

                <Button className="green-outline-btn" onClick={handleLabelsModalClick} sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px', border: '0px !important', bgcolor: '#D6ECD2!important' }}>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <LabelsIcon />
                        <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>وظایف و نشانه گذاری ها</Box>
                    </Box>
                    <ArrowRightIcon className="rotate-180-minus" />

                </Button>
                <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <HouseIcon />

                        <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>ارتباطات</Box>
                    </Box>
                    <ArrowRightIcon className="rotate-180-minus" />

                </Button>
                {/* <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <ShareIcon />
                        <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>اشتراک گذاری</Box>
                    </Box>
                    <ArrowRightIcon className="rotate-180-minus" />

                </Button> */}
                <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <SendIcon />

                        <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>ارسال</Box>
                    </Box>
                    <ArrowRightIcon className="rotate-180-minus" />

                </Button>
                <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <CalendarIcon />

                        <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>یادآوری</Box>
                    </Box>
                    <ArrowRightIcon className="rotate-180-minus" />

                </Button>
                {CheckPermissions(userInfo, "applicant_edit") ? <Button className="green-outline-btn" onClick={() => navigate(`/demand_edit/${propInfo.Id}`)} sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <PenIcon />

                        <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>ویرایش</Box>
                    </Box>
                    <ArrowRightIcon className="rotate-180-minus" />

                </Button> : ""}
                {CheckPermissions(userInfo, "applicant_archive") ? <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <BackUpIcon />
                        <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>بایگانی</Box>

                    </Box>
                    <ArrowRightIcon className="rotate-180-minus" />
                </Button> : ""}
                {CheckPermissions(userInfo, "applicant_delete") ? <Button onClick={handleClickOpenDeletePropModal} className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <DelIcon />

                        <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>حذف</Box>
                    </Box>
                    {/* <ArrowRightIcon className="rotate-180-minus" /> */}

                </Button> : ""}
                <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <MailIcon />

                        <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>ارسال پیام</Box>
                    </Box>
                    <ArrowRightIcon className="rotate-180-minus" />

                </Button>
                <Button className="green-outline-btn" onClick={() => {navigate(`/applicant/adapt/${propInfo.Id}/${propInfo.Row}`); handleMoreOptionsModalClose()}} sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <RoundArrowsIcon />

                        <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>انطباق سازی</Box>
                    </Box>
                    <ArrowRightIcon className="rotate-180-minus" />

                </Button>
            </Box>
        </Dialog>}

        {openLabelsModal && <Dialog className="dialog-box"
            fullScreen
            open={openLabelsModal}
            onClose={handleLabelsModalClose}
            TransitionComponent={Transition}
        >
            <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                <Toolbar>
                    <IconButton>
                        <SettingIcon />
                    </IconButton>
                    <Typography sx={{ mx: 'auto', fontSize: '12px' }} variant="h6" component="div">
                        نشانه گذاری ها
                    </Typography>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleLabelsModalClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>

                </Toolbar>
            </AppBar>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', pt: 3, gap: '20px', px: 4 }}>

                <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px', border: '0px !important', bgcolor: '#D6ECD2!important' }}>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <LabelsIcon />
                        <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>وظایف و نشانه گذاری ها</Box>
                    </Box>
                    <ArrowRightIcon className="rotate-180-minus" />

                </Button>
                <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <HouseIcon />

                        <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>ارتباطات</Box>
                    </Box>
                    <ArrowRightIcon className="rotate-180-minus" />

                </Button>
                {/* <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <ShareIcon />
                        <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>اشتراک گذاری</Box>
                    </Box>
                    <ArrowRightIcon className="rotate-180-minus" />

                </Button> */}
                <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <SendIcon />

                        <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>ارسال</Box>
                    </Box>
                    <ArrowRightIcon className="rotate-180-minus" />

                </Button>
                <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <CalendarIcon />

                        <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>یادآوری</Box>
                    </Box>
                    <ArrowRightIcon className="rotate-180-minus" />

                </Button>
                {CheckPermissions(userInfo, "applicant_edit") ? <Button className="green-outline-btn" onClick={() => navigate(`/demand_edit/${propInfo.Id}`)} sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <PenIcon />

                        <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>ویرایش</Box>
                    </Box>
                    <ArrowRightIcon className="rotate-180-minus" />

                </Button> : ""}
                {CheckPermissions(userInfo, "applicant_archive") ? <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <BackUpIcon />
                        <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>بایگانی</Box>

                    </Box>
                    <ArrowRightIcon className="rotate-180-minus" />
                </Button> : ""}
                {CheckPermissions(userInfo, "applicant_delete") ? <Button onClick={handleClickOpenDeletePropModal} className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <DelIcon />

                        <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>حذف</Box>
                    </Box>
                    {/* <ArrowRightIcon className="rotate-180-minus" /> */}

                </Button> : ""}
                <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <MailIcon />

                        <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>ارسال پیام</Box>
                    </Box>
                    <ArrowRightIcon className="rotate-180-minus" />

                </Button>
                <Button className="green-outline-btn" onClick={() => navigate(`/applicant/adapt/${propInfo.Id}/${propInfo.Row}`)} sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <RoundArrowsIcon />

                        <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>انطباق سازی</Box>
                    </Box>
                    <ArrowRightIcon className="rotate-180-minus" />

                </Button>
            </Box>
        </Dialog>}

        {ContactModal && <DemandContactModal ContactModal={ContactModal} handleContactModalClose={handleContactModalClose} propInfo={propInfo} />}

        {deletePropModal && <Dialog className="dialog-box"
            open={deletePropModal}
            onClose={handleDeletePropModalClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            {/* <Dialog className="dialog-box"Title id="alert-dialog-title">
                        
                    </DialogTitle> */}
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    آیا میخواهید این تقاضا را حذف کنید؟
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleDeletePropModalClose}>خیر</Button>
                <Button onClick={handleDelete} autoFocus>
                    {!deleteLading ? "بله" : <img src="/assets/img/ladng2.gif" width="20" />}
                </Button>
            </DialogActions>
        </Dialog>}

    </>);
}

export default PropItem;